import React from "react";
import { initialsFromName } from "../../lib/catalog";

export default function PersonCell({ name, subtitle, fallback = "-" }) {
  const displayName = String(name || "").trim();
  if (!displayName) {
    return fallback;
  }

  return (
    <div className="d-flex align-items-center agent-person-cell">
      <span className="agent-table-avatar flex-shrink-0">{initialsFromName(displayName)}</span>
      <div className="min-w-0 flex-grow-1">
        <span className="d-block text-secondary-light fw-semibold text-md text-break">{displayName}</span>
        {subtitle ? <span className="d-block text-sm text-secondary-light fw-normal text-break">{subtitle}</span> : null}
      </div>
    </div>
  );
}
